export const formatDate = (date: string | Date, locale: string): string => {
  return new Date(date).toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatTime = (date: string | Date, locale: string): string => {
  return new Date(date).toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateTime = (date: string | Date, locale: string): { date: string; time: string } => {
  return {
    date: formatDate(date, locale),
    time: formatTime(date, locale),
  };
};

/** The time alone when `date` is on the same day as `day`; otherwise date and time, so another day stays visible. */
export const formatTimeOnDay = (
  date: string | Date | null | undefined,
  day: string | Date | null | undefined,
  locale: string,
  fallback: string = "-"
): string => {
  if (!date) return fallback;
  if (!day || new Date(date).toDateString() !== new Date(day).toDateString()) {
    return formatDateTimeInline(date, locale, fallback);
  }

  return formatTime(date, locale);
};

export const formatDateTimeInline = (
  date: string | Date | null | undefined,
  locale: string,
  fallback: string = "-"
): string => {
  if (!date) return fallback;

  return new Date(date).toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
